import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../views/Index.vue'
import Login from '../views/Login.vue'
import Information from '../views/Information.vue'
import Welcome from '../views/Welcome.vue'
import TaIndex from '../views/taIndex.vue'
import cont1 from '../views/cont1.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'TaIndex',//TaIndex
    name: 'TaIndex',// TaIndex
    component: TaIndex,
    meta:{
      title:'天安导航页'
    }
  },
  {
    path: '/cont1',
    name: 'cont1',
    component: cont1,
    meta:{
      title:''
    }
  },
  // {
  //   path: '/login',
  //   name: 'login',
  //   component: Login,
  //   meta:{
  //     title:''
  //   }
  // },
  // {
  //   path: '/information',
  //   name: 'information',
  //   component: Information,
  //   meta:{
  //     title:''
  //   }
  // }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})


export default router
